/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	Box,
	NumberFormatter,
	Text,
} from '@mantine/core';
import classes from './Table.module.css';
import {
	convertGCO2EToTCO2EWithoutUnitFloor,
	uuid,
} from '@utils/functions';

import { useTranslation } from 'react-i18next';

import { NOT_APPLICABLE } from '@config/constants/common';
import { getUnitLabel } from '@utils/units';
import { getCurrencyUnit } from '@utils/currency-units';
import clsx from 'clsx';

const Table = (props: { rows: any }) => {
	const { t } = useTranslation();
	return (
		<Box className={classes.table}>
			<Box className={classes.header}>
				<Box className={classes.cell}>
					<Text className={classes.title}>
						{t('global.name')}
					</Text>
				</Box>
				<Box
					className={clsx(classes.cell, classes.cellEnd)}
				>
					<Text
						className={clsx(
							classes.title,
							classes.titleEnd
						)}
					>
						{t('global.offsetPerTone')}
					</Text>
				</Box>
				<Box
					className={clsx(classes.cell, classes.cellEnd)}
				>
					<Text
						className={clsx(
							classes.title,
							classes.titleEnd
						)}
					>
						{t('global.offsetAmount')}
					</Text>
				</Box>
			</Box>
			{props.rows &&
				props.rows.length !== 0 &&
				props.rows.map((item: any) => (
					<Box key={uuid()} className={classes.row}>
						<Box className={classes.cell}>
							<Text className={classes.value}>
								{item.name}
							</Text>
						</Box>
						<Box
							className={clsx(
								classes.cell,
								classes.cellEnd
							)}
						>
							<Box className={classes.value}>
								<NumberFormatter
									thousandSeparator=" "
									value={convertGCO2EToTCO2EWithoutUnitFloor(
										item?.offsetPerTone || 0
									)}
									suffix={' ' + getUnitLabel('tco2')}
									decimalScale={3}
								/>
							</Box>
						</Box>
						<Box
							className={clsx(
								classes.cell,
								classes.cellEnd
							)}
						>
							<Box className={classes.value}>
								<NumberFormatter
									className={classes.value}
									thousandSeparator=" "
									value={item?.offsetAmount || 0}
									suffix={' ' + getCurrencyUnit('EUR')}
									decimalScale={2}
								/>
							</Box>
						</Box>
					</Box>
				))}
			{props.rows && props.rows.length == 0 && (
				<Box key={uuid()} className={classes.row}>
					<Box className={classes.cell}>
						<Text className={classes.value}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
					<Box
						className={clsx(
							classes.cell,
							classes.cellEnd
						)}
					>
						<Text className={classes.value}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
					<Box
						className={clsx(
							classes.cell,
							classes.cellEnd
						)}
					>
						<Text className={classes.value}>
							{NOT_APPLICABLE}
						</Text>
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default Table;
